import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_divider = _resolveComponent("van-divider");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_form = _resolveComponent("van-form");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, null, {
    default: _withCtx(() => [_createVNode(_component_van_form, {
      onSubmit: $options.onSubmit
    }, {
      default: _withCtx(() => [_createVNode(_component_van_cell_group, null, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          modelValue: $data.form.chnName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.chnName = $event),
          type: "input",
          required: "",
          name: "chnName",
          label: "姓名",
          rules: [{
            required: true,
            message: '请输入姓名'
          }]
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: $data.form.idNo,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.idNo = $event),
          type: "input",
          required: "",
          name: "idNo",
          label: "身份证号",
          rules: [{
            required: true,
            message: '请输入身份证号'
          }]
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_van_divider), _createVNode(_component_van_button, {
        style: {
          "width": "100%"
        },
        type: "primary",
        "native-type": "submit",
        loading: $data.btnLoading
      }, {
        default: _withCtx(() => [_createTextVNode(" 查询 ")]),
        _: 1
      }, 8, ["loading"])]),
      _: 1
    }, 8, ["onSubmit"])]),
    _: 1
  });
}